import React, { Component } from 'react'

import { TablaReportePorSilos } from '../../shared/TablaReportePorSilos/containers/TablaReportePorSilos'

export class ReportePorSilosView extends Component {
  render () {
    return (
      <TablaReportePorSilos />
    )
  }
}
